import React from 'react';
import { getCurrentUser, signInWithRedirect, signOut } from 'aws-amplify/auth';
import { signOutRedirectUrl } from '../constants';
import Loader from '../components/Loader';
import SignOut from '../components/SignOut';
import SITE_PATHS from '../config/sitePaths';
import { savePostAuthRedirectURL } from '../utils/post-auth-redirect';

const isUserLoggedIn = async () => {
  try {
    await getCurrentUser();
    return true;
  } catch {
    return false;
  }
};

const buildSignInArgs = () => {
  const {
    pathname,
  } = window.location;
  if (!pathname.startsWith(SITE_PATHS.LOGIN)) return null;
  const [,, clientId] = pathname.split('/');
  if (!clientId) return null;
  return {
    provider: {
      custom: clientId,
    },
  };
};

export default function withAuthentication(Inner) {
  return class WithAuthentication extends React.Component {
    constructor(props) {
      super(props);
      this.state = {
        isAuthenticated: false,
        isLoading: true,
      };
    }

    async componentDidMount() {
      const isAuthenticated = await isUserLoggedIn();
      this.setState({ isAuthenticated, isLoading: false });
    }

    render() {
      if (this.state.isLoading) return (<Loader />);
      if (new RegExp(`${SITE_PATHS.SIGNOUT}$`).test(window.location.href)) {
        return (<SignOut isAuthenticated={this.state.isAuthenticated} signout={() => signOut({ oauth: { redirectUrl: signOutRedirectUrl } })} />);
      }
      if (this.state.isAuthenticated) {
        // eslint-disable-next-line react/jsx-props-no-spreading
        return (<Inner {...this.props} />);
      }
      savePostAuthRedirectURL();
      signInWithRedirect(buildSignInArgs());
      return null;
    }
  };
}
